<template>
  <div id="__UsageReport">
    <SideList />

    <div id="__UsageReport_Content">
      <router-view name="contents" ref="main-view" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import heroChartMixin from '@/components/CustomCharts/heroChartMixin';

import SideList from '@/pages/UsageReport/SideList';

const formatGroupBy = groupBy => {
  switch (groupBy) {
    case 'account':
      return 'account';
    case 'azure_subscription':
      return 'azure_subscription';
    case 'acc_group':
      return 'group';
    case 'cross_tag':
      return 'cross_tag';
    case 'report_filter':
      return 'report_filter';
    default:
      return '';
  }
};

export default {
  name: 'UsageReport',
  mixins: [heroChartMixin],
  components: { SideList },
  watch: {
    groupBy(groupBy) {
      // Reset each selected id of group by type and reset usage reports ID.
      this.updateIdAccount(null);
      this.updateIdGroup(null);
      this.updateIdCrossTag(null);
      this.updateIdReportFilter({ filterId: null });
      this.updateIdUsageReports(null);

      // Update resource type
      this.updateCondition({ key: 'resource', value: formatGroupBy(groupBy) });

      // Fetch list
      this.fetchList({ force: true });
    },

    async id(id) {
      if (id) {
        id = encodeURIComponent(id);
        this.$router.push(`/usage_reports/${formatGroupBy(this.groupBy)}/${id}`).catch(() => {});
      }
    },
  },
  async created() {
    // Group by
    const groupBy = this.$route.meta.group_by;

    // Set group by
    this.updateGroupBy(groupBy);

    // Go to ID
    if (this.id) {
      let id = encodeURIComponent(this.id);
      this.$router.push(`/usage_reports/${formatGroupBy(this.groupBy)}/${id}`).catch(() => {});
    }
  },
  computed: {
    ...mapState('usageReports', {
      groupBy: state => state.groupBy,
      id: state => state.id,
    }),
  },
  methods: {
    ...mapActions('usageReports', ['fetchList']),
    ...mapMutations('usageReports', {
      updateGroupBy: 'updateGroupBy',
      updateIdUsageReports: 'updateId',
    }),
    ...mapMutations('accounts', {
      updateIdAccount: 'updateSelectedId',
    }),
    ...mapMutations('groups', { updateIdGroup: 'updateSelectedId' }),
    ...mapMutations('crossTags', { updateIdCrossTag: 'updateSelectedId' }),
    ...mapMutations('reportFilters', { updateIdReportFilter: 'setActiveFilter' }),
  },
};
</script>

<style lang="scss" scoped>
#__UsageReport {
  display: flex;
  align-items: flex-start;
  padding: 0 $space-xs;

  &_Content {
    width: 100%;
    height: calc(100vh - 60px);
    overflow: auto;
    padding: $space-md $space-xs;
  }
}
</style>
